import { Box, Select as MuiSelect, SelectProps } from "@mui/material";
import ButtonBase from "@mui/material/ButtonBase";

import MuiTypography from "@mui/material/Typography";
import styled from "styled-components";


export const BaseButton = styled(ButtonBase)`
  width: 100%;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${(props) => props.color};
`;

export const Options = styled(Box)`
  display: flex;
  height: 30px;
  width: 100%;
  font-family: "NotoSans-Regular";
  font-size: 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 3px;
  background: #fff;
`;

export const Content = styled(Box)`
  padding: 16px 8px 16px 8px;
`;

export const ChipsWrapper = styled(Box)`
  display: flex;
`;

export const TypographyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  white-space: pre-wrap;
  margin-bottom: 30px;
`;

export const Typography = styled(MuiTypography)<{ color?: string }>`
  color: ${(props) => props.color || props.theme.text.primary};
  font-size: 16px;
  font-family: "NotoSans-Medium";
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;


export const BalanceWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: left;
  justify-content: center;
  autoWidth: true;
`;

export const TransactionsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  justify-content: center;
  autoWidth: true;
`;

export const ContentHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  max-height: calc(100% - 40px);
`;

export const Select = styled(MuiSelect)<SelectProps>`
  height: 32px;
  width: 100%;
`;

export const TitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(Typography)`
  color: #1d1d1d;
  font-size: 20px;
  font-family: "Outfit-SemiBold";
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;
